import { BACKEND_URL } from '@/core/config';
import { server } from '../core/server/axios';

interface LoadLoagByDateVariables {
	startDate: string;
	endDate: string;
	depId: string[] | number[];
}

export class LogsController {
	async loadLogsByDate(request: LoadLoagByDateVariables) {
		return await server.post(`/Rates/LogListByDate`, {
			startDate: `${request.startDate}T00:00:00.000000`,
			endDate: `${request.endDate}T23:59:59.999999`,
			depId: request.depId
		}, {
			baseURL: BACKEND_URL
		});
	}
}